import { SKILL_AOE_RANGE_WIDTH_PER_CARD } from "@/character/skills/constants";
import type { SkillDefinition } from "@/character/skills/types";
import type { HomeEconomy } from "@/home/economy";

export function isAoeAttackSkill(skill: SkillDefinition): boolean {
  return skill.kind === "attack" && skill.attackPattern === "aoe";
}

export function skillAoeRangeCardsApplied(skill: SkillDefinition): number {
  const n = skill.aoeRangeCards ?? 0;
  return Math.max(0, Math.floor(n));
}

/** 1.0 = base width; each card +1% (0.01). */
export function skillAoeRangeMultiplier(skill: SkillDefinition): number {
  if (!isAoeAttackSkill(skill)) return 1;
  const cards = skillAoeRangeCardsApplied(skill);
  return 1 + cards * SKILL_AOE_RANGE_WIDTH_PER_CARD;
}

export function formatAoeRangeBonusPercent(multiplier: number): string {
  const pct = (multiplier - 1) * 100;
  if (Math.abs(pct - Math.round(pct)) < 1e-6) {
    return String(Math.round(pct));
  }
  return pct.toFixed(1);
}

export type UpgradeSkillAoeRangeCardResult =
  | { ok: true; economy: HomeEconomy; skill: SkillDefinition }
  | { ok: false; reason: string };

export function upgradeSkillWithAoeRangeCard(
  economy: HomeEconomy,
  skill: SkillDefinition,
): UpgradeSkillAoeRangeCardResult {
  if (!isAoeAttackSkill(skill)) {
    return { ok: false, reason: "ใช้ได้กับสกิลโจมตีหมู่เท่านั้น" };
  }
  if (economy.skillAoeRangeCards < 1) {
    return { ok: false, reason: "ไม่มีบัตรระยะสกิลในคลัง · ซื้อที่ร้าน Cash" };
  }
  const applied = skillAoeRangeCardsApplied(skill);
  return {
    ok: true,
    economy: {
      ...economy,
      skillAoeRangeCards: economy.skillAoeRangeCards - 1,
    },
    skill: {
      ...skill,
      aoeRangeCards: applied + 1,
    },
  };
}
